// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"788":"5884a000","8889":"1c582e58"}[chunkId] || chunkId) + "." + {"54":"958e6fd41717e51c","788":"0af82746fa67c523","2352":"6ba97e8ba172cb40","5360":"eb200bf0beb23224","7491":"cfe563545d6f1e26","8889":"e35348d5e1666238"}[chunkId] + ".js";
};